module.exports = {
    title: {
        first: 'Domain Diagnostics',
        second: 'Comprehensive intelligent domain diagnostics to check the domain health status at any time'
    },
    header: {
        headerName: 'Diagnostics Items',
        headerResult: 'Diagnostics Result'
    },
    type: {
        whois: 'Whois Diagnostics',
        http: 'HTTP Diagnostics',
        ns: 'NS Diagnostics',
        trace: 'dig+trace Diagnostics'
    },
    column: {
        upTime: 'Update Time',
        exTime: 'Expiration Time',
        day: 'days',
        deadline: 'The Domain Will Expire in'
    },
    status: {
        domainNormal: 'This domain can be used normally',
        open: 'Enable JD Cloud DNS service',
        nsNormal: 'Proved normal by NS Detection',
        dnsNormal: 'The domain resolution is normal',
        not: 'Not Detected',
        det: 'Detection',
        status: 'Status',
        aStatus: 'A Record Status',
        fail: 'Detection failed'
    },
    detail: 'Details',
    close: 'Fold',
    period: '.',
    flag: 'en',
    tip: 'Please enter correct domain'
};
